import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#000',
      light: '#333',
      dark: '#000',
      contrastText: '#fff',
    },
    secondary: {
      main: '#19857b',
      light: '#4caf50',
      dark: '#00695f',
      contrastText: '#fff',
    },
    error: {
      main: '#F6333F',
    },
    warning: {
      main: '#ff9800',
    },
    info: {
      main: '#fff',
    },
    success: {
      main: '#4caf50',
    },
    background: {
      default: '#f9f9f9',
      paper: '#fff',
    },
    text: {
      primary: '#000',
      secondary: '#fff',
    },
  },
});

export default theme;
